import { render } from "./ProductScore.vue?vue&type=template&id=3b38843a&scoped=true"
import script from "./ProductScore.vue?vue&type=script&lang=js"
export * from "./ProductScore.vue?vue&type=script&lang=js"

import "./ProductScore.vue?vue&type=style&index=0&id=3b38843a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b38843a"]])

export default __exports__